import React, { useEffect, useState } from 'react';
import Chart from "react-apexcharts";
import { getApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';

const ChatOperatorPiChart = ({ selectedOperator }) => {

    const [series, setSeries] = useState([0, 0, 0, 0]);
    const [options, setOptions] = useState({
        chart: {
            type: 'donut',
        },
        labels: ['Total Hours', 'Online Hours Percentage', 'Online Hours', 'Offline Hours Percentage', 'Offline Hours'],
        colors: ['#43E5A0', '#00A383', '#144EE3', '#144EE361', '#EB568E'],
        stroke: {
            width: 0
        },
        tooltip: {
            enabled: true,
            y: {
                formatter: function (val) {
                    return (Number.parseFloat(val).toFixed(2))
                },
                title: {
                    formatter: (seriesName) => seriesName,
                },
            },
        },
        plotOptions: {
            pie: {
                offsetX: -100,
                donut: {
                    labels: {
                        show: true,
                        total: {
                            label: 'Chats',
                            show: true,
                            color: 'var(--secondary-text)',
                            fontSize: 12,
                            formatter: function (w) {
                                return w.globals.seriesTotals.reduce((a, b) => {
                                    let ans = a + b;
                                    return (Number.parseFloat(ans).toFixed(2))
                                }, 0)
                            }
                        },
                        value: {
                            color: 'var(--black)',
                            fontWeight: 'bold',
                            formatter: function (value) {
                                return (Number.parseFloat(value)?.toFixed(2))
                            }
                        }
                    }
                }
            }
        },
        dataLabels: {
            enabled: true
        },
        legend: {
            show: true,
            offsetY: 40,
            itemMargin: {
                horizontal: 0,
                vertical: 5
            },
            horizontalAlign: 'center', floating: true,
            onItemClick: {
                toggleDataSeries: true
            },
            onItemHover: {
                highlightDataSeries: true
            },
        }, responsive: [
            {
                breakpoint: 640,
                options: {
                    legend: {
                        floating: false,
                        position: "bottom"
                    }
                }
            }
        ]
    });

    async function getChartData() {
        let resp = await getApi(urlApi.chatOperatorAnalysis + selectedOperator?._id);
        if (resp.responseCode === 200) {
            setSeries([resp?.data?.totalHours || 0, resp?.data?.onlineHoursPercentage || 0, resp?.data?.onlineHours || 0, resp?.data?.offlineHoursPercentage || 0, resp?.data?.offlineHours || 0]);
        } else {
            setSeries([0, 0, 0, 0]);
            setOptions({ ...options, labels: ['Total Hours', 'Online Hours Percentage', 'Online Hours', 'Offline Hours Percentage', 'Offline Hours'] });
        }
    }

    useEffect(() => {
        if (selectedOperator?._id) {
            getChartData();
        }
        return () => {

        };
    }, [selectedOperator]);

    return (
        <div className='bg-white p-1.5 rounded-xl text-white h-max'>
            <div className="flex items-center p-1 !gap-2 mb-2">
                <p className='text-xs font-bold text-[var(--grey)]'>{`Operator Chat Analysis`}</p>
                {!selectedOperator && <p className='mb-0 text-xs font-light italic text-gray-500'>{'(Click Details of an Operator)'}</p>}
                {selectedOperator && <p className='mb-0 text-xs font-semibold text-gray-800'>Of <span className='underline'>{selectedOperator?.name || "Operator"}</span></p>}
            </div>
            <Chart options={options} series={series} height={260} width={'100%'} type="donut" />
        </div>
    )
}

export default ChatOperatorPiChart;